import { render } from "./VideoHeader.vue?vue&type=template&id=60f9166e"
import script from "./VideoHeader.vue?vue&type=script&lang=js"
export * from "./VideoHeader.vue?vue&type=script&lang=js"

import "./VideoHeader.vue?vue&type=style&index=0&id=60f9166e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__